import type { ContainerAddress } from "./backend";

export interface Address {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
}

export const mapToAddressType = (data: ContainerAddress): Address => {
  return {
    street: data.street,
    houseNumber: data.houseNumber,
    postalCode: data.postCode,
    city: data.city,
    country: data.countryCode,
  };
};
